import * as React from "react";
import type { SVGProps } from "react";
const Main = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    viewBox="0 0 66 66"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx={33} cy={33.5} r={25} fill="#FDFDFD" />
      <g strokeLinejoin="round">
        <circle cx={33} cy={33.5} r={26.5} stroke="#FFF" strokeWidth={3} />
        <circle cx={33} cy={33.5} r={26} stroke="#000" strokeWidth={2} />
      </g>
      <path
        fill="#000"
        d="m26.168 27.147 11.292-1.552 5.357 10.066-8.24 7.875-10.465-5.201zm-15.919-6.699q2.032-3.923 3.575-5.414 1.545-1.491 5.579-3.431l5.11 2.292-3.31 8.688-8.914 3.012zM59.3 32.485q-.252 3.94-.57 6.045-.32 2.104-2.35 5.927l-6.367.506-1.453-8.146 4.54-9.389zm-15.643 24.39q-4.224 1.874-6.383 2.041-2.157.168-6.858 0l-3.973-5.293 9.772-4.314 8.028 1.399zM11.635 49.66q-2.458-3.318-3-5.377A60 60 0 0 0 7.3 39.94l3.595-7.255 6.42 7.53.81 10zM38.373 9q3.428.383 5.414 1.23 1.986.849 5.217 3.764l.477 5.035-10.032-.43-7.603-6.414z"
      />
    </g>
  </svg>
);
export default Main;
